import * as React from 'react';
import { Icon } from '@grandvisionhq/icons';

const Tag = ({ children , onClick  })=>{
    return /*#__PURE__*/ React.createElement("button", {
        className: "tag",
        onClick: onClick,
        type: "button"
    }, children, /*#__PURE__*/ React.createElement(Icon, {
        className: "tag__clear",
        name: "clear"
    }));
};

export { Tag as default };
//# sourceMappingURL=Tag.js.map
